module.exports = __webpack_public_path__ + "static/desktop/img/step-mobile-calendar.c3a76f7e.png";